import type { FunctionComponent, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getMapPosition } from '../../components/molecules/MapPosition';
import Image from '../../components/atoms/Image';
import SpeechBubble from '../../components/atoms/SpeechBubble';
import AutofitText from '../../components/molecules/AutofitText';
import Text from '../../components/atoms/Text';
import Assets from '../../assets/Assets';

export interface Props {
	activePersonaIndex?: number;
}

const PersonasIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { activePersonaIndex } = props;
	const { t } = useTranslation();

	const renderPersonaSpeechBubble = (): ReactNode => {
		if (activePersonaIndex === undefined) {
			return undefined;
		}
		const activePersonaPosition = getMapPosition(activePersonaIndex);
		return (
			<SpeechBubble
				key="persona_speech_bubble"
				anchor="left_bottom"
				width="38vmin"
				height="24vmin"
				position="absolute"
				left={`calc(${activePersonaPosition.x} + 3vmin)`}
				top={`calc(${activePersonaPosition.y} - 20vmin)`}
				fadeInDelay={3_000}
				fadeInDuration={300}
			>
				<AutofitText>
					<Trans>introduction.personas.click_me</Trans>
				</AutofitText>
			</SpeechBubble>
		);
	};

	return (
		<>
			{renderPersonaSpeechBubble()}
			{/* Narrator */}
			<Image
				src={Assets.images['narrator.amazed.body']}
				width="38vmin"
				height="56vmin"
				position="absolute"
				left="0"
				bottom="0"
			/>
			<SpeechBubble
				key="narrator_speech_bubble"
				anchor="left_bottom"
				width="30%"
				height="28%"
				position="absolute"
				left="34vmin"
				bottom="26vmin"
				fadeInDelay={1_000}
				fadeInDuration={300}
			>
				<AutofitText>
					<Text
						content={t('introduction.personas.description', {
							returnObjects: true
						})}
					/>
				</AutofitText>
			</SpeechBubble>
		</>
	);
};

export default PersonasIntroScreen;
